// (() => {
//   if (customElements.get('product-form')) {
//     return;
//   }

//   class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');
//       this.submitButton = this.form.querySelector('[name="add"]');
//       this.cartDrawer = document.querySelector('cart-drawer');
//       this.productBar = document.querySelector(
//         `#ProductBar-${this.dataset.sectionId}`
//       );

//       this.form.addEventListener(
//         'submit',
//         this.onSubmitHandler.bind(this)
//       );
//     }

//     onSubmitHandler(event) {
//       event.preventDefault();
//       const purchaseOptions = document.querySelector(
//         'purchase-options'
//       );
//       if (
//         !!purchaseOptions &&
//         !purchaseOptions.isOneTimePurchase() &&
//         !this.hasAttribute('data-has-selling-plan')
//       ) {
//         purchaseOptions.showError();
//         return;
//       }

//       // this.submitButton.classList.add('disabled');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];
//       const formData = new FormData(this.form);
//       formData.append(
//         'sections',
//         this.cartDrawer
//           .getSectionsToRender()
//           .map(section => section.section)
//       );
//       formData.append('sections_url', window.location.pathname);
//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then(response => response.json())
//         .then(response => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.cartDrawer.renderContents(response);
//         })
//         .catch(error => {
//           console.error(error);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('disabled');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       const errorWrapper = this.querySelector('[data-error-wrapper]');
//       if (!errorWrapper) return;
//       errorWrapper.classList.toggle('hidden', !errorMessage);
//       errorWrapper.textContent = errorMessage || '';
//     }

//     toggleAddButton(disable, text) {
//       [
//         this.submitButton,
//         this.productBar?.querySelector('[name="add"]')
//       ].forEach(submitButton => {
//         if (disable) {
//           submitButton?.setAttribute('disabled', 'disabled');
//           if (text && submitButton) submitButton.textContent = text;
//         } else if (submitButton) {
//           submitButton.removeAttribute('disabled');
//           submitButton.textContent = this.hasAttribute(
//             'data-has-selling-plan'
//           )
//             ? window.variantStrings.addSubscriptionToCart
//             : window.variantStrings.addToCart;
//         }
//       });
//     }
//   }

//   customElements.define('product-form', ProductForm);
// })();









// (() => {
//   if (customElements.get('product-form')) return;

//   class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       if (!this.form) return;

//       this.submitButton    = this.form.querySelector('[name="add"]');
//       this.cartDrawer      = document.querySelector('cart-drawer');
//       this.errorWrapper    = this.querySelector('[data-error-wrapper]');
//       this.productHandle   = this.dataset.productHandle || '';
//       this.sectionId       = this.dataset.sectionId || '';

//       /* 
//         ✅ Always force a safe action so a native-submit fallback
//            never lands on /products/undefined 
//       */
//       this.cartAddUrl = (window.routes && window.routes.cart_add_url)
//         ? window.routes.cart_add_url
//         : '/cart/add';

//       this.form.setAttribute('action', this.cartAddUrl);
//       this.form.setAttribute('method', 'post');

//       this._boundSubmit = this._onSubmit.bind(this);
//       this.form.addEventListener('submit', this._boundSubmit);
//     }

//     disconnectedCallback() {
//       this.form?.removeEventListener('submit', this._boundSubmit);
//     }

//     /* ─── Submit ───────────────────────────────────────────── */

//     _onSubmit(event) {
//       event.preventDefault();        // ← must be first, always
//       event.stopPropagation();       // ← belt-and-braces: stop any other handlers

//       if (this.submitButton?.disabled) return;

//       this._clearError();
//       this._toggleButton(true);

//       const formData = new FormData(this.form);

//       /* Append sections for cart-drawer re-render */
//       if (this.cartDrawer?.getSectionsToRender) {
//         const sections = this.cartDrawer
//           .getSectionsToRender()
//           .map(s => s.section)
//           .filter(Boolean);

//         if (sections.length) {
//           formData.append('sections', sections.join(','));
//           formData.append('sections_url', window.location.pathname);
//         }
//       }

//       const config = {
//         method : 'POST',
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//           'Accept'          : 'application/javascript',
//         },
//         body: formData,
//       };

//       /* ✅ Log so you can confirm the URL in the network tab */
//       console.log('[ProductForm] posting to:', this.cartAddUrl);
//       console.log('[ProductForm] handle:', this.productHandle);

//       fetch(this.cartAddUrl, config)
//         .then(res => {
//           if (!res.ok) {
//             return res.json().then(data => {
//               throw new Error(data.description || `HTTP ${res.status}`);
//             });
//           }
//           return res.json();
//         })
//         .then(response => {
//           /* Shopify returns { status: 422, description: '...' } for errors */
//           if (response.status) {
//             throw new Error(response.description || 'Could not add to cart.');
//           }

//           if (this.cartDrawer?.renderContents) {
//             this.cartDrawer.renderContents(response);
//             requestAnimationFrame(() => this._openCartDrawer());
//           } else {
//             const cartUrl = (window.routes && window.routes.cart_url)
//               ? window.routes.cart_url
//               : '/cart';
//             window.location.href = cartUrl;
//           }
//         })
//         .catch(err => {
//           console.error('[ProductForm] Add to cart error:', err);
//           this._showError(err.message || 'Something went wrong. Please try again.');
//         })
//         .finally(() => {
//           this._toggleButton(false);
//         });
//     }

//     /* ─── Cart drawer ──────────────────────────────────────── */

//     _openCartDrawer() {
//       const drawer = this.cartDrawer;
//       if (!drawer) return;

//       if (typeof drawer.open === 'function') drawer.open();
//       drawer.classList.add('active');
//       drawer.setAttribute('open', '');

//       document.body.classList.add('cart-open', 'overflow-hidden');
//       document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
//     }

//     /* ─── UI helpers ───────────────────────────────────────── */

//     _toggleButton(loading) {
//       if (!this.submitButton) return;

//       this.submitButton.disabled    = loading;
//       this.submitButton.textContent = loading
//         ? (window.variantStrings?.adding  || 'Adding…')
//         : (window.variantStrings?.addToCart || 'Add to cart');

//       this.submitButton.setAttribute('aria-busy', loading ? 'true' : 'false');
//     }

//     _showError(message = '') {
//       if (!this.errorWrapper) return;
//       this.errorWrapper.textContent = message;
//       this.errorWrapper.classList.remove('hidden');
//     }

//     _clearError() {
//       if (!this.errorWrapper) return;
//       this.errorWrapper.textContent = '';
//       this.errorWrapper.classList.add('hidden');
//     }
//   }

//   customElements.define('product-form', ProductForm);
// })();


(() => {
  if (customElements.get('product-form')) return;

  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.submitButton = this.form.querySelector('[name="add"]');
      this.errorWrapper = this.querySelector('[data-error-wrapper]');
      this.productHandle = this.dataset.productHandle || '';
      this.sectionId = this.dataset.sectionId || '';

      this.cartAddUrl = (window.routes && window.routes.cart_add_url)
        ? window.routes.cart_add_url
        : '/cart/add';

      this.form.setAttribute('action', this.cartAddUrl);
      this.form.setAttribute('method', 'post');

      this._boundSubmit = this._onSubmit.bind(this);
      this.form.addEventListener('submit', this._boundSubmit);
    }

    get cartDrawer() {
      return (
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification') ||
        null
      );
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this._boundSubmit);
    }

    _onSubmit(event) {
      event.preventDefault();

      if (this.submitButton?.disabled) return;

      this._clearError();
      this._toggleButton(true);

      const formData = new FormData(this.form);
      const drawer = this.cartDrawer;

      if (drawer?.getSectionsToRender) {
        const sections = drawer
          .getSectionsToRender()
          .map(s => s.section)
          .filter(Boolean);

        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
        },
        body: formData,
      };

      fetch(this.cartAddUrl, config)
        .then(res => {
          if (!res.ok) {
            return res.json().then(data => {
              throw new Error(data.description || `HTTP ${res.status}`);
            });
          }
          return res.json();
        })
        .then(response => {
          if (response.status) {
            throw new Error(response.description || 'Could not add to cart.');
          }

          this._triggerSmartCart(response);
        })
        .catch(err => {
          console.error('[ProductForm] Add to cart error:', err);
          this._showError(err.message || 'Something went wrong. Please try again.');
        })
        .finally(() => {
          this._toggleButton(false);
        });
    }

    _triggerSmartCart(response) {
      const events = [
        'cart:item-added',
        'cart:updated',
        'cart:open',
        'CartItemAdded',
        'ajaxProduct:added',
        'product:added-to-cart',
      ];

      events.forEach(name => {
        document.dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: { response, product: response }
        }));
      });

      if (window.SmartCart && typeof window.SmartCart.open === 'function') {
        window.SmartCart.open();
      }

      if (window.SmartCart && typeof window.SmartCart.refresh === 'function') {
        window.SmartCart.refresh();
      }

      const drawer = this.cartDrawer;
      if (drawer?.renderContents) {
        drawer.renderContents(response);
        requestAnimationFrame(() => {
          if (typeof drawer.open === 'function') drawer.open();
        });
      }

      /* ✅ NO REDIRECT — page stays as-is after add to cart */
      // window.location.href = window.routes?.cart_url || '/cart';
    }

    _toggleButton(loading) {
      if (!this.submitButton) return;

      this.submitButton.disabled = loading;
      this.submitButton.textContent = loading
        ? (window.variantStrings?.adding || 'Adding…')
        : (window.variantStrings?.addToCart || 'Add to cart');

      this.submitButton.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    _showError(message = '') {
      if (!this.errorWrapper) return;
      this.errorWrapper.textContent = message;
      this.errorWrapper.classList.remove('hidden');
    }

    _clearError() {
      if (!this.errorWrapper) return;
      this.errorWrapper.textContent = '';
      this.errorWrapper.classList.add('hidden');
    }
  }

  customElements.define('product-form', ProductForm);
})();